import { z } from 'zod';
export const CoordinatesSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
});
export const ReachabilityItemSchema = z.object({
    distance_meters: z.number(),
    duration_seconds: z.number(),
});
export const RegionSchema = z.object({
    code: z.string(),
    name: z.string(),
    type: z.string(),
});
export const ValuationRegionTypeSchema = z.enum([
    'Gemeinde',
    'Gemeindefreies Gebiet',
    'Stadt',
    'Kreisfreie Stadt',
    'Kreis',
    'Landkreis',
    'Stadtkreis',
    'Land',
    'Freistaat',
    'Freie und Hansestadt',
    'Hansestadt',
    'Bundesrepublik',
    'Postleitzahl',
]);
